import { useRefInputStore } from "@/state/stores";
import { useEffect } from "react";

const options = [
  "a calendar sync API 🗓️",
  "a Slack office presence bot 🤖",
  "a Discord chatbot 🤖",
  "something cool 🧊",
  "an AI knowledge base API 📚",
  "a weather API 🌤️",
  "a recipe builder 🍕",
  "a travel itinerary builder 🗺️",
  "an incident response chatbot 🚨",
] as const;

export function usePlaceholderAnimation(hasAutomatedPlaceholders: boolean) {
  const textareaRef = useRefInputStore(({ inputRef }) => inputRef);

  useEffect(() => {
    if (!hasAutomatedPlaceholders || !textareaRef.current) {
      return;
    }

    const textarea = textareaRef.current;
    let currentIndex = 0;
    let typingTimeout: ReturnType<typeof setTimeout>;

    const typeOption = () => {
      if (textarea.value.length > 0) {
        textarea.placeholder = "Build me a...";
        return;
      }

      const option = options[currentIndex];
      let charIndex = 0;

      const reverseType = () => {
        if (charIndex <= 0) {
          currentIndex = (currentIndex + 1) % options.length;
          typeOption();
          return;
        }

        charIndex--;
        textarea.placeholder = `Build me ${option.slice(0, charIndex)}`;
        typingTimeout = setTimeout(reverseType, 50);
      };

      const typeCharacter = () => {
        textarea.placeholder = `Build me ${option.slice(0, charIndex + 1)}`;
        charIndex++;

        if (charIndex < option.length) {
          typingTimeout = setTimeout(typeCharacter, 30);
          return;
        }

        typingTimeout = setTimeout(reverseType, 1200);
      };

      typeCharacter();
    };

    const initialTimeout = setTimeout(typeOption, 1200);

    return () => {
      clearTimeout(typingTimeout);
      clearTimeout(initialTimeout);
    };
  }, [textareaRef, hasAutomatedPlaceholders]);
}
